import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StopwatchComponent } from './stopwatch.component';
import { LottieComponent } from 'ngx-lottie';
import { ButtonModule } from 'primeng/button';



@NgModule({
  declarations: [StopwatchComponent],
  imports: [
    CommonModule,
    LottieComponent,
    ButtonModule
  ],
  exports:[StopwatchComponent]
})
export class StopwatchModule { }
